import { OwnerModel } from './owner.model';
import { CoOwnerModel } from './co-owner.model';

export class OwnerDataModel extends OwnerModel {

  coOwners?: CoOwnerModel[];

  constructor() {
    super();
    this.coOwners = [];
  }
}
